import {OnFailure, OnSuccess} from "../actionHelpers";
import {Dispatch} from "react-redux";
import {api} from "../../../api/api";
import AssetAttribute from "../../../model/assetAttribute/AssetAttribute";
import {Action} from "redux-actions";
import {ASSET_ATTRIBUTES_FETCHED} from "./actionType";

/**
 * Asset attributes fetched successful action.
 * @param {Array<AssetAttribute>} assetAttributes all asset attributes from server.
 * @return {Action<ASSET_ATTRIBUTES_FETCHED>}
 */
function assetAttributesFetched(assetAttributes: Array<AssetAttribute>): Action<ASSET_ATTRIBUTES_FETCHED> {
	return {type: ASSET_ATTRIBUTES_FETCHED, payload: {assetAttributes}};
}

/**
 * Fetch asset attributes from server.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchAssetAttributes(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.assetApi.fetchAssetAttributes().then(assetAttributes => {
			dispatch(assetAttributesFetched(assetAttributes));
			onSuccess();
		}).catch(onFailure);
	};
}